/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ExportAssignmentFilesDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('files')],
    [
        'userIds',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecNumber)),
        'user_ids',
    ],
]);
export class ExportAssignmentFilesData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ExportAssignmentFilesDataParser.decode(input).map(res => new ExportAssignmentFilesData(res));
    }
    static unsafeDecode(input) {
        return ExportAssignmentFilesData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExportAssignmentFilesDataParser.encode(data);
    }
    static schema() {
        return ExportAssignmentFilesDataParser.schema();
    }
}
